/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: npm run preprocess:generate-new
 * Generated at: 2026-05-06T00:55:44.704Z
 *
 * Index of basic training sections
 * Use lazy imports to load section data on demand
 */

export interface SectionMetadata {
  id: string;
  title: string;
  description: string;
  introducedChars: string[];
  isPrerequisite: boolean;
  prerequisites: string[];
  classCount: number;
  fileName: string;
}

export const basicSectionsMetadata: SectionMetadata[] = [
  {
    "id": "home-row",
    "title": "Home Row",
    "description": "Master the home row with balanced left-right hand pairs",
    "introducedChars": [
      "f",
      "j",
      "d",
      "k",
      "s",
      "l",
      "a",
      ";"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 7,
    "fileName": "section-1-home-row.ts"
  },
  {
    "id": "top-row",
    "title": "Top Row",
    "description": "Reach up from home row with balanced pairs",
    "introducedChars": [
      "r",
      "u",
      "e",
      "i",
      "w",
      "o",
      "q",
      "p"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 15,
    "fileName": "section-2-top-row.ts"
  },
  {
    "id": "bottom-row",
    "title": "Bottom Row",
    "description": "Reach down from home row with balanced pairs",
    "introducedChars": [
      "v",
      "m",
      "c",
      ",",
      "x",
      ".",
      "z",
      "/"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 22,
    "fileName": "section-3-bottom-row.ts"
  },
  {
    "id": "middle-keys",
    "title": "Middle Keys",
    "description": "Index finger reaches inward to middle columns",
    "introducedChars": [
      "g",
      "h",
      "t",
      "y",
      "b",
      "n"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 10,
    "fileName": "section-4-middle-keys.ts"
  },
  {
    "id": "uppercase-home",
    "title": "Uppercase - Home Row",
    "description": "Capital letters on home row with balanced pairs",
    "introducedChars": [
      "F",
      "J",
      "D",
      "K",
      "S",
      "L",
      "A",
      ":"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 15,
    "fileName": "section-5-uppercase-home.ts"
  },
  {
    "id": "uppercase-top",
    "title": "Uppercase - Top Row",
    "description": "Capital letters on top row with balanced pairs",
    "introducedChars": [
      "R",
      "U",
      "E",
      "I",
      "W",
      "O",
      "Q",
      "P"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 21,
    "fileName": "section-6-uppercase-top.ts"
  },
  {
    "id": "uppercase-bottom",
    "title": "Uppercase - Bottom Row",
    "description": "Capital letters on bottom row with balanced pairs",
    "introducedChars": [
      "V",
      "M",
      "C",
      "<",
      "X",
      ">",
      "Z",
      "?"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 29,
    "fileName": "section-7-uppercase-bottom.ts"
  },
  {
    "id": "uppercase-middle",
    "title": "Uppercase - Middle Keys",
    "description": "Capital letters on middle columns",
    "introducedChars": [
      "G",
      "H",
      "T",
      "Y",
      "B",
      "N"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 15,
    "fileName": "section-8-uppercase-middle.ts"
  },
  {
    "id": "numbers",
    "title": "Numbers",
    "description": "Number row 0-9 with balanced left-right pairs",
    "introducedChars": [
      "5",
      "6",
      "4",
      "7",
      "3",
      "8",
      "2",
      "9",
      "1",
      "0"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 9,
    "fileName": "section-9-numbers.ts"
  },
  {
    "id": "punctuation-basic",
    "title": "Basic Punctuation",
    "description": "Common punctuation marks",
    "introducedChars": [
      "!",
      "'",
      "\""
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 4,
    "fileName": "section-10-punctuation-basic.ts"
  },
  {
    "id": "number-row-symbols",
    "title": "Number Row Symbols",
    "description": "Symbols above number keys (shift+numbers)",
    "introducedChars": [
      "%",
      "^",
      "$",
      "&",
      "#",
      "*",
      "@",
      "(",
      ")"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 25,
    "fileName": "section-11-number-row-symbols.ts"
  },
  {
    "id": "special-chars-right",
    "title": "Right-Side Special Characters",
    "description": "Programming symbols on the right side of keyboard",
    "introducedChars": [
      "-",
      "_",
      "=",
      "+",
      "[",
      "]",
      "{",
      "}",
      "\\",
      "|",
      "`",
      "~"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 13,
    "fileName": "section-12-special-chars-right.ts"
  }
];

/**
 * Lazy-load a section by ID.
 * Uses an explicit switch with static import paths so Vite can statically
 * analyze and code-split each section bundle.
 */
export async function loadBasicsSection(sectionId: string) {
  switch (sectionId) {
    case 'home-row':
      return (await import('./section-1-home-row')).section;
    case 'top-row':
      return (await import('./section-2-top-row')).section;
    case 'bottom-row':
      return (await import('./section-3-bottom-row')).section;
    case 'middle-keys':
      return (await import('./section-4-middle-keys')).section;
    case 'uppercase-home':
      return (await import('./section-5-uppercase-home')).section;
    case 'uppercase-top':
      return (await import('./section-6-uppercase-top')).section;
    case 'uppercase-bottom':
      return (await import('./section-7-uppercase-bottom')).section;
    case 'uppercase-middle':
      return (await import('./section-8-uppercase-middle')).section;
    case 'numbers':
      return (await import('./section-9-numbers')).section;
    case 'punctuation-basic':
      return (await import('./section-10-punctuation-basic')).section;
    case 'number-row-symbols':
      return (await import('./section-11-number-row-symbols')).section;
    case 'special-chars-right':
      return (await import('./section-12-special-chars-right')).section;
    default:
      throw new Error(`Section not found: ${sectionId}`);
  }
}
